module.exports = __webpack_public_path__ + "static/media/56b738a7-54b9-4e8c-a470-d96972ab3303.7d5d94ce.eot";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/56b738a7-54b9-4e8c-a470-d96972ab3303.eot
// module id = 93
// module chunks = 0